module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ijiymM/tc-custom/9781591813231.jpg?1733089697855",
      "alt": "This image is the cover for the book Song of Trusting the Heart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Song of Trusting the Heart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The timeless Zen poem is beautifully translated and updated for modern readers, with each stanza gorgeously illustrated for daily meditation.")]), _c('br'), _c('br'), _vm._v("Enlivening the spirit without overwhelming the mind, the poem Hsin-Hsin Ming, or Song of Trusting the Heart, was written in the sixth century by the third Zen patriarch of China. The work is considered the most encompassing and profound expression of Zen awareness. Its haunting verses inspire a peaceful awakening that helps one see through attachments, judgments, and illusions."), _c('br'), _c('br'), _vm._v("Tamarack Song’s rendition updates this beloved text to make it accessible to contemporary readers. Each stanza is illustrated with captivating brush paintings by sumi-e master Jan Zaremba to create a beautiful and easy-to-use meditation guide for the twenty-nine-day lunar month. A tool for reflection on the most profound aspects of life, each day’s stanza cuts through the mind’s clutter, bringing clarity and guidance.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tamarack Song, Jan Zaremba\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Sentient Publications\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0